// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3rkD_","productName":"Table_productName__2UM8N"};